// identity_icon：2  显示皇冠图标
// identity_icon：7  显示打钩图标
// identity_icon：3  显示推主图标
// identity_icon：1  显示开发者图标
<template>
  <div class="area" v-if="recoList">

    <div class="areaHead">
        <div class="it">玩家评价</div>
    </div>
    <!-- 星际评分 -->
    <Star :itData='starInfo' />

    <div class="comment-btn">
        <a class="fl" @click="popdown"><i class="it1"></i>我要安利</a>
        <a class="fr" @click="popdown"><i class="it2"></i>我要评价</a>
    </div>
 
    <div class="comment-list">
      <Citem v-for="(item,index) in commitList" :key="item.id" :itData="item" :isReco="true" />
    </div>
 
    
    <div v-if="commitList.length==0">
      <div class="comment-nodata" >
        这里欠缺一位像你这样勇于发言的人
        <br />
        <a @click="popdown">现在去发言</a>
      </div>
    </div>

    <div class="show-comment" v-if="recoList.count>0">
      <span @click="toList">查看全部<i>{{recoList.count | numFormat}}</i>评价</span>
    </div>
  </div>
</template>

<script>
import Api from '@/tool/Api'
import Tool from '@/tool/tool';
import Star from '@/components/Cstar.vue'
import Citem from "@/components/Citem.vue";


// import Tool from '@/tool/tool'
// import Bus from '@/tool/bus'

export default {
  data(){
    return{
      pid:window.pid,
      fid:window.fid,
      limit: 3, //单页显示评论数
      isAnli:1, //是否显示安利
      recoList:null,//优质评论
      commitList:[],//优质评论
      starInfo:null,//星级数据,
      Count:0,
      isNone:false
    }
  },
  components: {
    Star,
    Citem
  },
  mounted(){    
    //获取数据
    this.getData();
  },
  methods: {

    getData(){      
      Api.getComment({
          get_recommend:this.isAnli,
          limit:this.limit,
          fid:this.fid,
          pid:this.pid
      }).then(res=>{
        if(res.code==100){
          // 优质评论
          this.recoList=res.result.data
          //星级
          this.starInfo=res.result.star_info;
          let {list}=res.result.data;

          this.commitList=list.filter(item=>{return item.state>0})
          //执行页面评分设置
          window.comInit.comTotal(
            (({count,count_str,star}) =>({count, count_str,star}))(this.starInfo)
          );
          //安利数据 
          if(res.result.recommend){
            this.$root.BUS.$emit("anli", res.result.recommend);
          }    
          //评论总数
          if(res.result.data.hasOwnProperty("count")){
            if(res.result.data.count==0){
              this.isNone=true;
            }else{
              this.Count = res.result.data.count;
              
            }
          }
          console.log()

        }     
      })
    },
    //外部下载弹窗
    popdown(){
      window.comInit.downTips();
    },
    starbar(num){
      return Tool.ToolPercent(num);
    },
    //评论详情
    toView(pid,fid,cid){
      Tool.toView(pid,fid,cid);
    },
    //展开评论
    showFold(index){
      this.recoList.list[index].fold_info.fold_status=0
    },
    //跳转评论
    toList(){
      window.pjPanel && window.pjPanel();     
    },
    rulelink(id){
      return "https://m.bbs.3839.com/thread-"+id+".htm"
    },
  }
}
</script>
